<div class="warning-circle">
	<alaris-icon name="icon-warning-circle"></alaris-icon>
</div>
